import React, { useState } from "react";

function Support({ user }) {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {q: "When do my products go live?", a: "Once you publish a product inside your Seller Portal, it indexes immediately in the IM Online customer catalog and becomes visible to buyers."},
    {q: "How do I manage my inventory?", a: "Go to Products in the sidebar, find your product, and click Edit to update stock quantities, pricing, or product details at any time."},
    {q: "What happens when I reach my product limit?", a: "When you reach your plan's product limit, the Add Product button will be disabled. You can upgrade your subscription plan to unlock more product slots."},
    {q: "How do I contact seller support?", a: "Email us at support@imonline.shop. Our team typically responds within 24-48 hours on business days."},
    {q: "What are the commission rates?", a: "Basic plan: 10% marketplace commission. Growth plan: 5% commission. Pro plan: 0% marketplace commission. Note that payment gateway and shipping costs may still apply."},
    {q: "How do I update my store information?", a: "Go to My Store in the sidebar. You can update your store name, description, contact info, and fulfillment address at any time."},
    {q: "How do I upgrade my subscription plan?", a: "Go to Subscription in the sidebar and click on the plan you want to upgrade to. You will be guided through the upgrade process."},
    {q: "What should I do if I face a problem?", a: "First check this Help section for common answers. If you cannot find a resolution, email support@imonline.shop with details of the issue."},
  ];

  const guides = [
    {title:"How to list a product?", text:"Navigate to Products, click + Add Product, fill in the product name, description, price, stock, sizes, colors, and upload product images. Click Submit when done."},
    {title:"How to take catalog photos?", text:"Use natural daylight. Photograph from side, top, and front perspectives. Use a plain white or neutral background. Ensure the product fills most of the frame."},
    {title:"Pricing strategy guidelines", text:"Compare similar products on IM Online. Factor in your cost price, marketplace commission, and packaging. A 20-40% margin is generally recommended for sustainability."},
    {title:"How to process orders?", text:"Order fulfillment is coming in the next phase of IM Online. Currently focus on getting your store and products set up and ready."},
  ];

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h2>We&#x2019;re Here to Help</h2>
          <p>Everything you need to successfully run your IM Online seller store.</p>
        </div>
      </div>

      {/* New seller callout */}
      <div style={{background:"var(--primary-light)",border:"1px solid rgba(168,80,80,0.2)",borderRadius:"12px",padding:"18px 22px",marginBottom:"24px",display:"flex",alignItems:"center",gap:"16px"}}>
        <div style={{fontSize:"28px"}}>&#x1F44B;</div>
        <div>
          <div style={{fontWeight:"700",color:"var(--dark)",marginBottom:"4px"}}>New to selling on IM Online?</div>
          <div style={{fontSize:"13px",color:"var(--text-muted)"}}>Start with the Seller Onboarding Guide below and the FAQ section. Most common questions are answered there.</div>
        </div>
      </div>

      {/* 4 Support Cards */}
      <div className="row g-4 mb-4">
        {[
          {icon:"&#x1F4DA;",label:"Seller Guide",sub:"Step-by-step guides for new sellers",bg:"#e8f4fd",href:null},
          {icon:"&#x2753;",label:"FAQ",sub:"Common questions answered",bg:"#f0fdf4",href:null},
          {icon:"&#x1F4AC;",label:"Contact Support",sub:"Email our seller support team",bg:"#fef3f2",href:"mailto:support@imonline.shop"},
          {icon:"&#x1F680;",label:"Getting Started",sub:"Your first steps as a seller",bg:"#faf5ff",href:null},
        ].map((c,i)=>(
          <div key={i} className="col-md-3 col-sm-6">
            {c.href ? (
              <a href={c.href} className="support-card">
                <div className="support-card-icon" style={{background:c.bg}} dangerouslySetInnerHTML={{__html:c.icon}} />
                <h6 style={{fontWeight:"700",marginBottom:"4px"}}>{c.label}</h6>
                <p style={{fontSize:"13px",color:"var(--text-muted)",margin:0}}>{c.sub}</p>
              </a>
            ) : (
              <div className="support-card">
                <div className="support-card-icon" style={{background:c.bg}} dangerouslySetInnerHTML={{__html:c.icon}} />
                <h6 style={{fontWeight:"700",marginBottom:"4px"}}>{c.label}</h6>
                <p style={{fontSize:"13px",color:"var(--text-muted)",margin:0}}>{c.sub}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="row g-4 mb-4">
        {/* Seller Guide */}
        <div className="col-lg-6">
          <div className="card-brand" style={{padding:"24px",height:"100%"}}>
            <h5 style={{fontWeight:"700",color:"var(--primary)",marginBottom:"16px"}}>&#x1F4DA; Seller Onboarding Guide</h5>
            {guides.map((g,i)=>(
              <div key={i} style={{padding:"14px 0",borderBottom: i < guides.length-1 ? "1px solid var(--border)" : "none"}}>
                <h6 style={{fontWeight:"700",marginBottom:"6px",color:"var(--dark)"}}>{g.title}</h6>
                <p style={{fontSize:"13px",color:"var(--text-muted)",margin:0,lineHeight:"1.6"}}>{g.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="col-lg-6">
          <div className="card-brand" style={{padding:"24px",height:"100%"}}>
            <h5 style={{fontWeight:"700",color:"var(--primary)",marginBottom:"16px"}}>&#x2753; Frequently Asked Questions</h5>
            {faqs.map((faq,i)=>(
              <div key={i} className={openFaq === i ? "faq-item open" : "faq-item"} style={{borderRadius:"8px",marginBottom:"8px"}}>
                <div className="faq-question" onClick={()=>setOpenFaq(openFaq===i ? null : i)}>
                  <span style={{fontSize:"14px"}}>{faq.q}</span>
                  <span className="faq-icon">+</span>
                </div>
                <div className={openFaq === i ? "faq-answer open" : "faq-answer"}>
                  <div className="faq-answer-inner">{faq.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="card-brand" style={{padding:"32px",textAlign:"center"}}>
        <h5 style={{fontWeight:"700",color:"var(--dark)",marginBottom:"8px"}}>Still need assistance?</h5>
        <p style={{color:"var(--text-muted)",fontSize:"14px",marginBottom:"20px",maxWidth:"400px",margin:"0 auto 20px"}}>Our dedicated seller support team is ready to help you with any questions or issues.</p>
        <a href="mailto:support@imonline.shop" className="btn btn-primary" style={{padding:"12px 28px"}}>
          &#x2709; Email Seller Support
        </a>
      </div>
    </div>
  );
}
export default Support;
